import api from './index';
const endpoints = {
    mailingList: '/admin/mailing-list',
};
export const downloadMailingList = async () => {
    const res = await api.get(endpoints.mailingList, { responseType: 'blob' });
    const filenameMatch = res.headers['content-disposition']?.match(/filename="(.+)"/);
    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filenameMatch ? filenameMatch[1] : 'compass-mailing-list.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
